// // BankAuction.js
// import React, { useContext, useState, useEffect, useRef } from 'react';
// import MyLocationIcon from "@mui/icons-material/MyLocation";
// import InputAdornment from "@mui/material/InputAdornment";
// import { useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   Paper,
//   Stack,
//   IconButton
// } from '@mui/material';
// import {
//     Landscape,
//     Home,
//     Storefront,
//     House,
//     Apartment,
//     BusinessCenter,
//     Villa,
//     HolidayVillage,
//     OtherHouses,
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import FormsBottomNavbar from './FormsBottomNavbar';
// import SearchBar from './PostBack';
// import { AuthContext } from '../../AuthContext/AuthContext';
// import { BASE_URL } from '../../Api/ApiUrls';
// import { checkBankAuctionUploadLimit } from "./checkBankAuctionUploadLimit";
// import SubscriptionModal from "./SubscriptionModal";
// import GuestLoginModal from '../../GuestLoginModal';
// import { CircularProgress } from '@mui/material';
// import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
// import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
// import FullScreenLoader from '../../FullScreenLoader';
// import { GOOGLEMAPS_API_KEY } from '../../Api/ApiUrls';
// import {
//   GoogleMap,
//   useLoadScript,
//   Autocomplete
// } from "@react-google-maps/api";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';


// const FilterContainer = styled(Paper)(({ theme }) => ({
//   padding: '16px',
//   margin: '8px',
//   borderRadius: '12px',
//   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//   backgroundColor: '#fff',
//   minHeight: "75vh",
//   marginBottom: "80px"
// }));

// const SectionTitle = styled(Typography)(({ theme }) => ({
//   fontWeight: 'bold',
//   fontSize: '16px',
//   marginBottom: '12px',
//   color: '#333'
// }));

// const containerStyle = {
//   width: "100%",
//   height: "300px",
//   borderRadius: "12px",
//   overflow: "hidden",
// };

// const StyledButton = styled(Button)(({ theme }) => ({
//   backgroundColor: '#c47f4eff',
//   color: 'white',
//   fontWeight: 'bold',
//   borderRadius: '8px',
//   padding: '8px 16px',
//   '&:hover': {
//     backgroundColor: '#b38454ff',
//   },
// }));

// const FileItem = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   padding: '8px 12px',
//   margin: '4px 0',
//   backgroundColor: '#f8f9fa',
//   borderRadius: '6px',
//   border: '1px solid #e9ecef',
// }));

// const FileInfo = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: '8px',
//   flex: 1,
// }));

// const centerDefault = { lat: 17.3850, lng: 78.4867 };

// const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;

// // ✅ Fields that only accept digits + optional single decimal point
// const NUMERIC_ONLY_FIELDS = ['area', 'reservePrice', 'emdAmount', 'bidIncrement'];

// const BankAuction = () => {
//   const { userId, isGuest } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const [uploadStatus, setUploadStatus] = useState(null);
//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");

//   const autocompleteRef = useRef(null);
//   const mapRef = useRef(null);

//   useEffect(() => {
//     const checkSubscription = async () => {
//       const result = await checkBankAuctionUploadLimit(userId);
//       setUploadStatus(result);
//       if (!result.canUpload) {
//         setShowStatusModal(true);
//       }
//     };
//     if (userId) checkSubscription();
//   }, [userId]);

//   useEffect(() => {
//     if (isGuest) {
//       setShowGuestModal(true);
//     }
//   }, [isGuest]);

//   const [formData, setFormData] = useState({
//     auctionId: '',
//     bankName: '',
//     propertyType: '',
//     actionType: '',
//     location: '',
//     lat: '',
//     long: '',
//     cityTown: '',
//     areaTown: '',
//     area: '',
//     possession: '',
//     reservePrice: '',
//     possessionStatus: '',
//     emdAmount: '',
//     bidIncrement: '',
//     emdSubmission: '',
//     auctionStartDate: '',
//     auctionEndDate: '',
//     bankContact: '',
//     downloadAuctionFile: '',
//     description: ''
//   });

//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [locationOptions, setLocationOptions] = useState([]);
//   const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
//   const autocompleteServiceRef = useRef(null);
//   const [location, setLocation] = useState(centerDefault);
//   const [address, setAddress] = useState("");
//   const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
//   const [locationConfirmed, setLocationConfirmed] = useState(false);

//   useEffect(() => {
//     const initGoogleMaps = () => {
//       if (window.google && window.google.maps && window.google.maps.places) {
//         setIsGoogleLoaded(true);
//         autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
//         return true;
//       }
//       return false;
//     };

//     if (initGoogleMaps()) return;

//     if (!window.google) {
//       const script = document.createElement("script");
//       script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLEMAPS_API_KEY}&libraries=places`;
//       script.async = true;
//       script.defer = true;
//       script.onload = () => {
//         if (initGoogleMaps()) {
//           console.log("✅ Google Maps API loaded successfully");
//         }
//       };
//       script.onerror = () => {
//         console.error("❌ Failed to load Google Maps API");
//       };
//       document.head.appendChild(script);
//     }

//     return () => {
//       autocompleteServiceRef.current = null;
//     };
//   }, []);

//   // ✅ Central change handler with numeric validation
//   const handleFormDataChange = (field, value) => {
//     if (NUMERIC_ONLY_FIELDS.includes(field)) {
//       // Allow empty string or digits with optional single decimal point
//       if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
//     }
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   const fetchPlaces = (input) => {
//     if (!input || input.length < 3 || !isGoogleLoaded || !autocompleteServiceRef.current) {
//       setLocationOptions([]);
//       return;
//     }
//     autocompleteServiceRef.current.getPlacePredictions(
//       {
//         input,
//         types: ["geocode", "establishment"],
//         componentRestrictions: { country: "in" }
//       },
//       (predictions, status) => {
//         if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
//           setLocationOptions(predictions.map((p) => p.description));
//         } else {
//           setLocationOptions([]);
//         }
//       }
//     );
//   };

//   const debouncedFetchPlaces = useRef(null);

//   useEffect(() => {
//     debouncedFetchPlaces.current = debounce(fetchPlaces, 300);
//   }, [isGoogleLoaded]);

//   function debounce(func, wait) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }

//   const [workPhotos, setWorkPhotos] = useState([]);
  
//   const handleWorkPhotosChange = (e) => {
//     const files = Array.from(e.target.files || []);
  
//     if (files.length > 4) {
//       alert("You can upload a maximum of 4 images only");
//       e.target.value = "";
//       return;
//     }
  
//     const validFiles = files.filter((file) =>
//       file.type.startsWith("image/")
//     );
  
//     if (validFiles.length !== files.length) {
//       alert("Please select image files only");
//       e.target.value = "";
//       return;
//     }
  
//     setWorkPhotos(validFiles);
//   };
  
//   const handleRemovePhoto = (index) => {
//     setWorkPhotos((prev) =>
//       prev.filter((_, i) => i !== index)
//     );
//   };
  

//   const getCurrentLocation = () => {
//     if (navigator.geolocation) {
//       setUsingCurrentLocation(true);
//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           const pos = {
//             lat: position.coords.latitude,
//             lng: position.coords.longitude,
//           };
//           setLocation(pos);
//           try {
//             const response = await fetch(
//               `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
//             );
//             const data = await response.json();
//             if (data.status == 'OK' && data.results.length > 0) {
//               setAddress(data.results[0].formatted_address);
//             } else {
//               setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
//             }
//           } catch (error) {
//             console.error('Google Maps API error:', error);
//             setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
//           }
//         },
//         (error) => {
//           console.error("Error getting current location:", error);
//           alert("Error getting current location. Please enable location services.");
//         }
//       );
//     } else {
//       alert("Geolocation is not supported by this browser.");
//     }
//   };

//   const onPlaceChanged = () => {
//     if (autocompleteRef.current) {
//       const place = autocompleteRef.current.getPlace();
//       if (place && place.geometry) {
//         setUsingCurrentLocation(false);
//         const newLoc = {
//           lat: place.geometry.location.lat(),
//           lng: place.geometry.location.lng(),
//         };
//         setLocation(newLoc);
//         setAddress(place.formatted_address);
//       }
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.bankName.trim()) newErrors.bankName = "Bank name is required";
//     if (!formData.propertyType) newErrors.propertyType = "Please select a property type";
//     if (!address || address.trim() === '') newErrors.location = "Please select a location";
//     if (!formData.reservePrice) newErrors.reservePrice = "Reserve price is required";
//     if (!formData.emdAmount) newErrors.emdAmount = "EMD amount is required";
//     if (!formData.auctionStartDate) newErrors.auctionStartDate = "Auction start date is required";
//     if (!formData.auctionEndDate) newErrors.auctionEndDate = "Auction end date is required";
//       if (formData.auctionStartDate && formData.auctionEndDate) {
//     const start = new Date(formData.auctionStartDate);
//     const end = new Date(formData.auctionEndDate);
//     if (end <= start) {
//       newErrors.auctionEndDate = "End date must be after start date";
//     }
//   }
//     if (!formData.bankContact.trim()) newErrors.bankContact = "Bank contact is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

 
// const handleSave = async () => {
//   if (isGuest) {
//     setShowGuestModal(true);
//     return;
//   }

//   if (workPhotos.length > 4) {
//     alert("You can upload a maximum of 4 images only");
//     return;
//   }

//   if (!validateForm()) return;

//   setLoading(true);

//   try {
//     const check = await checkBankAuctionUploadLimit(userId);

//     if (!check.canUpload) {
//       setUploadStatus(check);
//       setShowStatusModal(true);
//       return;
//     }

//     const formPayload = new FormData();

//     formPayload.append("user_id", userId);
//     formPayload.append("bank_name", formData.bankName);
//     formPayload.append("property_type", formData.propertyType);
//     formPayload.append("action_type", formData.actionType);
//     formPayload.append("location", address || "");
//     formPayload.append("lat", location?.lat || "");
//     formPayload.append("long", location?.lng || "");
//     formPayload.append("city_town", formData.cityTown);
//     formPayload.append("area_town", formData.areaTown);
//     formPayload.append("area", formData.area);
//     formPayload.append("units", "");
//     formPayload.append("possession", formData.possession);
//     formPayload.append("reserve_price", formData.reservePrice);
//     formPayload.append("possession_status", formData.possessionStatus);
//     formPayload.append("emd_amount", formData.emdAmount);
//     formPayload.append("bid_increment", formData.bidIncrement);
//     formPayload.append("emd_submission", formData.emdSubmission);
//     formPayload.append("auction_start_datetime", formData.auctionStartDate);
//     formPayload.append("auction_end_datetime", formData.auctionEndDate);
//     formPayload.append("bank_contact_details", formData.bankContact);
//     formPayload.append("description", formData.description);
//     formPayload.append("admin_status", "Pending");

//     // Existing document uploads
//     selectedFiles.forEach((file) => {
//       formPayload.append("new_documents", file);
//     });

//     // Property image uploads (maximum 4)
//     workPhotos.forEach((file) => {
//       formPayload.append("new_property_images", file);
//     });

//     console.log("📤 Submitting auction with documents:", selectedFiles.length);
//     console.log("🖼️ Property images:", workPhotos.length);

//     const response = await fetch(`${BASE_URL}/auction-property/`, {
//       method: "POST",
//       body: formPayload,
//     });

//     if (response.ok) {
//       const result = await response.json();
//       console.log("✅ Auction saved successfully:", result);

//       setAlertMessage("Auction saved successfully!");
//       setShowSuccess(true);
//     } else {
//       const errorText = await response.text();
//       console.error("❌ Failed to save auction:", errorText);

//       setAlertMessage("Failed to save auction. Please try again.");
//       setShowFailure(true);
//     }
//   } catch (err) {
//     console.error("🚨 Error:", err);
//     setAlertMessage("An error occurred while saving. Please try again.");
//     setShowFailure(true);
//   } finally {
//     setLoading(false);
//   }
// };


//   const handleCancel = () => navigate(-1);
//   const handleBackClick = () => navigate(-1);

//   const propertyTypeOptions = [
//     'Plots',
//     'Residential Building',
//     'Commercial Building',
//     'Land',
//     'Flat',
//     'House',
//     'Villa'
//   ];

//   const propertyTypeIcons = {
//   'Plots': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <Home sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'Residential Building': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <House sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'Commercial Building': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <BusinessCenter sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'Land': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <Landscape sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'Flat': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <Apartment sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'House': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <House sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
//   'Villa': (
//     <Box sx={{
//       width: 32,
//       height: 32,
//       borderRadius: '50%',
//       backgroundColor: '#F5EAD8',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <Villa sx={{ color: '#8B6914', fontSize: 20 }} />
//     </Box>
//   ),
// };
//   return (
//     <>
//       <SearchBar onBackClick={handleBackClick} />

//       <Box sx={{
//         padding: '16px',
//         backgroundColor: '#f5f1eb',
//         minHeight: '100vh',
//         height: '100%',
//         marginTop: "15%",
//         paddingBottom: "80px"
//       }}>
//         <FilterContainer>
//           {/* Basic Information */}
//           <SectionTitle>Basic Information</SectionTitle>

//           <FormControl fullWidth sx={{ mb: 2 }} size="small">
//             <TextField
//               label="Bank Name *"
//               value={formData.bankName}
//               onChange={(e) => { handleFormDataChange('bankName', e.target.value); setErrors(prev => ({ ...prev, bankName: '' })); }}
//               variant="outlined"
//               size="small"
//               error={!!errors.bankName}
//               helperText={errors.bankName || ''}
//             />
//           </FormControl>
// <FormControl fullWidth sx={{ mb: 2 }} size="small" error={!!errors.propertyType}>
//   <InputLabel 
//     id="property-type-label"
//     sx={{
//       color: '#8B6914',
//       '&.Mui-focused': {
//         color: '#8B6914',
//       }
//     }}
//   >
//     Property Type *
//   </InputLabel>
//   <Select
//     labelId="property-type-label"
//     value={formData.propertyType}
//     label="Property Type *"
//     sx={{
//       '& .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#8B6914',
//       },
//       '&:hover .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#6B4F12',
//       },
//       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#8B6914',
//         borderWidth: '2px',
//       },
//       '& .MuiSelect-select': {
//         display: 'flex',
//         alignItems: 'center',
//         gap: 1,
//       }
//     }}
//   MenuProps={{
//       PaperProps: {
//         sx: {
//           maxHeight: 440,
//           '& .MuiMenuItem-root': {
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1.5,
//         padding: '2px 16px',
//         minHeight: '32px',
//           },
//           '& .MuiMenuItem-root.Mui-selected': {
//             backgroundColor: '#F5EDE4',
//             '&:hover': {
//               backgroundColor: '#E8DDD0',
//             }
//           },
//           '& .MuiMenuItem-root:hover': {
//             backgroundColor: '#F5EDE4',
//           }
//         }
//       }
//     }}
//     onChange={(e) => { 
//       handleFormDataChange('propertyType', e.target.value); 
//       setErrors(prev => ({ ...prev, propertyType: '' })); 
//     }}
//     renderValue={(selected) => (
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {selected && propertyTypeIcons[selected]}
//         <Typography sx={{ color: '#3D2B1F' }}>
//           {selected || 'Select Property Type'}
//         </Typography>
//       </Box>
//     )}
//   >
//     {propertyTypeOptions.map((type) => (
//       <MenuItem 
//         key={type} 
//         value={type}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 2,
//           padding: '8px 16px',
//           '&:hover': {
//             backgroundColor: '#F5EDE4 !important',
//           },
//           '&.Mui-selected': {
//             backgroundColor: '#E8DDD0 !important',
//             '&:hover': {
//               backgroundColor: '#E8DDD0 !important',
//             }
//           }
//         }}
//       >
//         <Box sx={{ minWidth: 30 }}>
//           {propertyTypeIcons[type] || <Home sx={{ color: '#8B6914', fontSize: 20 }} />}
//         </Box>
//         <Typography sx={{ color: '#3D2B1F', fontWeight: 500 }}>
//           {type}
//         </Typography>
//       </MenuItem>
//     ))}
//   </Select>
//   {errors.propertyType && (
//     <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5, ml: 1.5 }}>
//       {errors.propertyType}
//     </Typography>
//   )}
// </FormControl>

//           <TextField
//             fullWidth
//             label="Action Type"
//             placeholder="Enter action type"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.actionType}
//             onChange={(e) => handleFormDataChange('actionType', e.target.value)}
//           />

//           {/* Location Details */}
//           <SectionTitle>Location Details</SectionTitle>

//           <Box sx={{ mb: 2 }}>
//             <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
//               Location
//             </Typography>

//             <Autocomplete
//               onLoad={(autocomplete) => {
//                 autocompleteRef.current = autocomplete;
//               }}
//               onPlaceChanged={onPlaceChanged}
//             >
//               <TextField
//                 fullWidth
//                 label="Search Location *"
//                 variant="outlined"
//                 value={address}
//                 onChange={(e) => { setAddress(e.target.value); setErrors(prev => ({ ...prev, location: '' })); }}
//                 error={!!errors.location}
//                 helperText={errors.location || ''}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={getCurrentLocation} edge="end">
//                         <MyLocationIcon />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Autocomplete>

//             <div style={{ ...containerStyle, position: 'relative' }}>
//               <GoogleMap
//                 mapContainerStyle={{ width: '100%', height: '100%' }}
//                 center={location}
//                 zoom={15}
//                 options={{ gestureHandling: 'greedy' }}
//                 onLoad={(map) => { mapRef.current = map; }}
//                 onDragStart={() => setLocationConfirmed(false)}
//               />

//               {/* Fixed pin at center */}
//               <div style={{
//                 position: 'absolute', top: '50%', left: '50%',
//                 transform: 'translate(-50%, -100%)', pointerEvents: 'none', zIndex: 10,
//               }}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
//                   <path fill="#ff0000" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
//                 </svg>
//               </div>

//               {/* Confirm location button */}
//               <button
//                 type="button"
//                 onClick={() => {
//                   if (window.google && window.google.maps && mapRef.current) {
//                     const center = mapRef.current.getCenter();
//                     const lat = center.lat();
//                     const lng = center.lng();
//                     setLocation({ lat, lng });
//                     const geocoder = new window.google.maps.Geocoder();
//                     geocoder.geocode({ location: { lat, lng } }, (results, status) => {
//                       if (status === 'OK' && results[0]) {
//                         const selectedAddress = results[0].formatted_address;
//                         setAddress(selectedAddress);
//                         setFormData(prev => ({
//                           ...prev,
//                           location: selectedAddress,
//                           lat: lat.toString(),
//                           long: lng.toString(),
//                         }));
//                       } else {
//                         const fallback = `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
//                         setAddress(fallback);
//                         setFormData(prev => ({
//                           ...prev,
//                           location: fallback,
//                           lat: lat.toString(),
//                           long: lng.toString(),
//                         }));
//                       }
//                       setLocationConfirmed(true);
//                     });
//                   }
//                 }}
//                 style={{
//                   display: 'flex', alignItems: 'center', justifyContent: 'center',
//                   backgroundColor: locationConfirmed ? 'green' : 'red',
//                   border: 'none', borderRadius: '50%', width: '44px', height: '44px',
//                   cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
//                   position: 'absolute', right: '10px', top: '45%',
//                   transform: 'translateY(-50%)', zIndex: 10,
//                   transition: 'background-color 0.3s ease',
//                 }}
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
//                   <path fill="white" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
//                 </svg>
//               </button>
//             </div>
//           </Box>

//           <TextField
//             fullWidth
//             label="City/Town"
//             placeholder="e.g. Bangalore"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.cityTown}
//             onChange={(e) => handleFormDataChange('cityTown', e.target.value)}
//           />

//           <TextField
//             fullWidth
//             label="Area/Town"
//             placeholder="e.g., Yeswanthpura"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.areaTown}
//             onChange={(e) => handleFormDataChange('areaTown', e.target.value)}
//           />

//           {/* ✅ Area — numeric only */}
//           <TextField
//             fullWidth
//             label="Area"
//             placeholder="e.g., 900"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.area}
//             onChange={(e) => handleFormDataChange('area', e.target.value)}
//             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
//           />

//           {/* Possession Details */}
//           <SectionTitle>Possession Details</SectionTitle>

//           <FormControl fullWidth sx={{ mb: 2 }} size="small">
//             <InputLabel>Possession Status</InputLabel>
//             <Select
//               value={formData.possessionStatus}
//               label="Possession Status"
//               onChange={(e) => handleFormDataChange('possessionStatus', e.target.value)}
//             >
//               <MenuItem value="Physical">Physical</MenuItem>
//               <MenuItem value="Symbolic">Symbolic</MenuItem>
//               <MenuItem value="Symbolic/Physical">Symbolic/Physical</MenuItem>
//             </Select>
//           </FormControl>

//           {/* Auction Details */}
//           <SectionTitle>Auction Details</SectionTitle>

//           {/* ✅ Reserve Price — numeric only, required */}
//           <TextField
//             fullWidth
//             label="Reserve Price *"
//             placeholder="e.g., 3132000"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.reservePrice}
//             onChange={(e) => { handleFormDataChange('reservePrice', e.target.value); setErrors(prev => ({ ...prev, reservePrice: '' })); }}
//             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
//             error={!!errors.reservePrice}
//             helperText={errors.reservePrice || ''}
//           />

//           {/* ✅ EMD Amount — numeric only, required */}
//           <TextField
//             fullWidth
//             label="EMD Amount *"
//             placeholder="e.g., 313200"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.emdAmount}
//             onChange={(e) => { handleFormDataChange('emdAmount', e.target.value); setErrors(prev => ({ ...prev, emdAmount: '' })); }}
//             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
//             error={!!errors.emdAmount}
//             helperText={errors.emdAmount || ''}
//           />

//           {/* ✅ Bid Increment — numeric only */}
//           <TextField
//             fullWidth
//             label="Bid Increment"
//             placeholder="e.g., 10000"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.bidIncrement}
//             onChange={(e) => handleFormDataChange('bidIncrement', e.target.value)}
//             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
//           />

//           <TextField
//             fullWidth
//             label="EMD Submission Date & Time"
//             type="datetime-local"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             InputLabelProps={{ shrink: true }}
//             value={formData.emdSubmission}
//             onChange={(e) => handleFormDataChange('emdSubmission', e.target.value)}
//           />

//           <TextField
//             fullWidth
//             label="Auction Start Date & Time *"
//             type="datetime-local"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             InputLabelProps={{ shrink: true }}
//             value={formData.auctionStartDate}
//             onChange={(e) => { handleFormDataChange('auctionStartDate', e.target.value); setErrors(prev => ({ ...prev, auctionStartDate: '' })); }}
//             error={!!errors.auctionStartDate}
//             helperText={errors.auctionStartDate || ''}
//           />

//           <TextField
//             fullWidth
//             label="Auction End Date & Time *"
//             type="datetime-local"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             InputLabelProps={{ shrink: true }}
//             value={formData.auctionEndDate}
//             onChange={(e) => { handleFormDataChange('auctionEndDate', e.target.value); setErrors(prev => ({ ...prev, auctionEndDate: '' })); }}
//             error={!!errors.auctionEndDate}
//             helperText={errors.auctionEndDate || ''}
//           />

//           {/* Contact & Files */}
//           <SectionTitle>Contact & Documents</SectionTitle>

//           {/* Bank Contact — digits only, required */}
//           <TextField
//             fullWidth
//             label="Bank Contact Details *"
//             placeholder="e.g., 9876543210"
//             variant="outlined"
//             size="small"
//             sx={{ mb: 2 }}
//             value={formData.bankContact}
//             onChange={(e) => {
//               const value = e.target.value.replace(/\D/g, "");
//               handleFormDataChange("bankContact", value);
//               setErrors(prev => ({ ...prev, bankContact: '' }));
//             }}
//             type="tel"
//             inputProps={{
//               inputMode: "numeric",
//               pattern: "[0-9]*",
//               maxLength: 10,
//             }}
//             error={!!errors.bankContact}
//             helperText={errors.bankContact || ''}
//           />


// {/* Property Image Upload */}
// <Box sx={{ mt: 3, mb: 2, width: "100%" }}>
//   <Typography
//     variant="subtitle1"
//     sx={{ fontWeight: "bold", mb: 1, color: "#3D2B1F" }}
//   >
//     Upload Property Images
//   </Typography>

//   <Button
//     component="label"
//     variant="outlined"
//     fullWidth
//     startIcon={<CloudUploadIcon />}
//     disabled={loading || isGuest}
//     sx={{
//       py: 1.5,
//       borderColor: "#8B6914",
//       color: "#8B6914",
//       borderRadius: "8px",
//       "&:hover": {
//         borderColor: "#6B4F12",
//         backgroundColor: "rgba(139, 105, 20, 0.04)",
//       },
//     }}
//   >
//     Upload Images

//     <input
//       type="file"
//       accept="image/*"
//       multiple
//       hidden
//       onChange={handleWorkPhotosChange}
//     />
//   </Button>

//   <Typography
//     variant="caption"
//     sx={{ color: "#8B6914", display: "block", mt: 1 }}
//   >
//     Maximum 4 images allowed
//   </Typography>

//   {workPhotos.length > 0 && (
//     <Box sx={{ mt: 2 }}>
//       <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
//         Selected Images ({workPhotos.length}/4)
//       </Typography>

//       {workPhotos.map((file, index) => (
//         <Stack
//           key={`${file.name}-${index}`}
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//           sx={{
//             p: 1,
//             mb: 1,
//             border: "1px solid #e0d5c5",
//             borderRadius: "8px",
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//               flex: 1,
//               mr: 1,
//             }}
//           >
//             {file.name}
//           </Typography>

//           <Button
//             size="small"
//             color="error"
//             onClick={() => handleRemovePhoto(index)}
//           >
//             Remove
//           </Button>
//         </Stack>
//       ))}
//     </Box>
//   )}
// </Box>


// {/* Description */}
// <Box sx={{ mt: 2, mb: 2 }}>
//   <Typography
//     variant="subtitle1"
//     gutterBottom
//     sx={{ fontWeight: "bold", color: "#3D2B1F" }}
//   >
//     Description
//   </Typography>

//   <TextField
//     fullWidth
//     variant="outlined"
//     multiline
//     rows={4}
//     inputProps={{ maxLength: 1500 }}
//     name="description"
//     value={formData.description || ""}
//     onChange={(e) =>
//       handleFormDataChange("description", e.target.value)
//     }
//     placeholder="Enter property description..."
//     disabled={loading || isGuest}
//     sx={{ mb: 1 }}
//   />

//   <Typography
//     variant="caption"
//     sx={{ color: "#8B6914" }}
//   >
//     {(formData.description || "").length}/1500
//   </Typography>
// </Box>

//           <>
//             {/* Full Screen Loader */}
//             <FullScreenLoader open={loading} text="Saving..." />

//             <Stack direction="row" spacing={1} sx={{ mt: 3, mb: 2 }}>
//               <Button
//                 variant="outlined"
//                 fullWidth
//                 onClick={handleCancel}
//                 disabled={loading}
//                 sx={{
//                   borderRadius: '8px',
//                   borderColor: '#8B4513',
//                   color: '#8B4513',
//                   '&:hover': {
//                     borderColor: '#654321',
//                     backgroundColor: 'rgba(139, 69, 19, 0.04)'
//                   }
//                 }}
//               >
//                 Cancel
//               </Button>

//               <StyledButton
//                 fullWidth
//                 onClick={handleSave}
//                 disabled={loading || isGuest || (uploadStatus && !uploadStatus.canUpload)}
//               >
//                 {uploadStatus && !uploadStatus.canUpload
//                   ? "Upload Limit Reached"
//                   : isGuest
//                   ? "Login to Save"
//                   : "Save"}
//               </StyledButton>
//             </Stack>
//           </>
//         </FilterContainer>
//       </Box>

//       <SubscriptionModal
//         open={showStatusModal}
//         type={uploadStatus?.reason === "NO_SUBSCRIPTION" ? "NO_SUBSCRIPTION" : "LIMIT_EXCEEDED"}
//         onClose={() => setShowStatusModal(false)}
//       />

//       <GuestLoginModal
//         open={showGuestModal}
//         onClose={() => setShowGuestModal(false)}
//       />

//       {showSuccess && (
//         <SuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowSuccess(false);
//             navigate("/dashboard");
//           }}
//         />
//       )}

//       {showFailure && (
//         <FailureAlert
//           message={alertMessage}
//           onClose={() => {
//             console.log("Closing failure alert");
//             setShowFailure(false);
//             setAlertMessage("");
//             navigate("/post-bank-properties");
//           }}
//         />
//       )}

//       <FormsBottomNavbar />
//     </>
//   );
// };

// export default BankAuction;




// BankAuction.js
import React, { useContext, useState, useEffect, useRef } from 'react';
import MyLocationIcon from "@mui/icons-material/MyLocation";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Paper,
  Stack,
  IconButton
} from '@mui/material';
import {
    Landscape,
    Home,
    Storefront,
    House,
    Apartment,
    BusinessCenter,
    Villa,
    HolidayVillage,
    OtherHouses,
    // Highlights icons
    Security,
    FitnessCenter,
    SportsBasketball,
    DirectionsRun,
    ChildCare,
    Park,
    SelfImprovement,
    WorkspacePremium,
    SportsScore,
    Videocam,
    BeachAccess,
    Forest,
    Pool,
    Lock,
    LocationCity,
    DirectionsCar,
    Description,
    CheckCircle,
    // Amenities icons
    Theaters,
    Celebration,
    LocalLibrary,
    LocalCafe,
    Hotel,
    DirectionsBike,
    Spa,
    SportsTennis,
    SportsCricket,
    SportsSoccer,
    SportsVolleyball,
    RollerSkating,
    Doorbell,
    Phone,
    DoorFront,
    People,
    LocalFireDepartment,
    ExitToApp,
    Bolt,
    WaterDrop,
    Business,
    DeleteOutline,
    WbSunny,
    EvStation,
    LocalGasStation,
    Elevator,
    SupportAgent,
    Chair,
    Build,
    CleaningServices,
    Deck,
    ChildFriendly,
    LocalPharmacy,
    LocalAtm,
    ContentCut,
    LocalLaundryService,
    LocalHospital,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FormsBottomNavbar from './FormsBottomNavbar';
import SearchBar from './PostBack';
import { AuthContext } from '../../AuthContext/AuthContext';
import { BASE_URL } from '../../Api/ApiUrls';
import { checkBankAuctionUploadLimit } from "./checkBankAuctionUploadLimit";
import SubscriptionModal from "./SubscriptionModal";
import GuestLoginModal from '../../GuestLoginModal';
import { CircularProgress } from '@mui/material';
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
import FullScreenLoader from '../../FullScreenLoader';
import { GOOGLEMAPS_API_KEY } from '../../Api/ApiUrls';
import {
  GoogleMap,
  useLoadScript,
  Autocomplete
} from "@react-google-maps/api";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const FilterContainer = styled(Paper)(({ theme }) => ({
  padding: '16px',
  margin: '8px',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
  minHeight: "75vh",
  marginBottom: "80px"
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '16px',
  marginBottom: '12px',
  color: '#333'
}));

const containerStyle = {
  width: "100%",
  height: "300px",
  borderRadius: "12px",
  overflow: "hidden",
};

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#c47f4eff',
  color: 'white',
  fontWeight: 'bold',
  borderRadius: '8px',
  padding: '8px 16px',
  '&:hover': {
    backgroundColor: '#b38454ff',
  },
}));

const FileItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px',
  margin: '4px 0',
  backgroundColor: '#f8f9fa',
  borderRadius: '6px',
  border: '1px solid #e9ecef',
}));

const FileInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
}));

const centerDefault = { lat: 17.3850, lng: 78.4867 };

const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;

// ✅ Fields that only accept digits + optional single decimal point
const NUMERIC_ONLY_FIELDS = ['area', 'reservePrice', 'emdAmount', 'bidIncrement'];

// ============================================================
// HIGHLIGHTS & AMENITIES CONFIG (ported from SellYourProperty)
// ============================================================
const ICON_KEYS = {
  "Swimming Pool": "pool",
  Gym: "gym",
  "Gated Community": "gate",
  "Near Metro": "metro",
};

const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const getIconKey = (label) => ICON_KEYS[label] || slugify(label);

const highlightOptions = [
  { label: "24-7 Security", icon: <Security /> },
  { label: "Power Backup", icon: <Security /> },
  { label: "Gym", icon: <FitnessCenter /> },
  { label: "Indoor Games", icon: <SportsBasketball /> },
  { label: "Jogging Track", icon: <DirectionsRun /> },
  { label: "Children Play Area", icon: <ChildCare /> },
  { label: "Senior Citizen Park", icon: <Park /> },
  { label: "Yoga Deck", icon: <SelfImprovement /> },
  { label: "Multipurpose Club Hall", icon: <WorkspacePremium /> },
  { label: "Mini Theatre", icon: <SportsScore /> },
  { label: "Co-working Space", icon: <BusinessCenter /> },
  { label: "EV Charging", icon: <Videocam /> },
  { label: "Visitor Parking", icon: <Storefront /> },
  { label: "Rain Water Harvesting", icon: <BeachAccess /> },
  { label: "Landscape Garden", icon: <Forest /> },
  { label: "CCTV", icon: <Videocam /> },
  { label: "Club House", icon: <Home /> },
  { label: "Swimming Pool", icon: <Pool /> },
  { label: "Gated Community", subtitle: "24/7 Security", icon: <Lock /> },
  { label: "2, 3 & 4 BHK", subtitle: "Configurations", icon: <Apartment /> },
  { label: "High Rise", subtitle: "Premium Living", icon: <LocationCity /> },
  { label: "Covered Parking", subtitle: "1 & 2 Cars", icon: <DirectionsCar /> },
  { label: "Swimming Pool", subtitle: "With Kids Pool", icon: <Pool /> },
  { label: "RERA Registered", subtitle: "Verified Project", icon: <Description /> },
];

const amenitiesOptions = [
  // Recreation
  { label: "Swimming Pool", category: "Recreation", icon: <Pool /> },
  { label: "Kids Pool", category: "Recreation", icon: <Pool /> },
  { label: "Club House", category: "Recreation", icon: <Home /> },
  { label: "Indoor Games", category: "Recreation", icon: <SportsBasketball /> },
  { label: "Mini Theatre", category: "Recreation", icon: <Theaters /> },
  { label: "Party Hall", category: "Recreation", icon: <Celebration /> },
  { label: "Library", category: "Recreation", icon: <LocalLibrary /> },
  { label: "Cafe", category: "Recreation", icon: <LocalCafe /> },
  { label: "Guest Rooms", category: "Recreation", icon: <Hotel /> },

  // Fitness & Wellness
  { label: "Gym", category: "Fitness & Wellness", icon: <FitnessCenter /> },
  { label: "Yoga Room", category: "Fitness & Wellness", icon: <SelfImprovement /> },
  { label: "Jogging Track", category: "Fitness & Wellness", icon: <DirectionsRun /> },
  { label: "Cycling Track", category: "Fitness & Wellness", icon: <DirectionsBike /> },
  { label: "Spa", category: "Fitness & Wellness", icon: <Spa /> },
  { label: "Sauna", category: "Fitness & Wellness", icon: <Spa /> },
  { label: "Steam Room", category: "Fitness & Wellness", icon: <Spa /> },
  { label: "Meditation Area", category: "Fitness & Wellness", icon: <SelfImprovement /> },
  { label: "Fitness Centre", category: "Fitness & Wellness", icon: <FitnessCenter /> },

  // Sports
  { label: "Tennis Court", category: "Sports", icon: <SportsTennis /> },
  { label: "Basketball Court", category: "Sports", icon: <SportsBasketball /> },
  { label: "Badminton Court", category: "Sports", icon: <SportsTennis /> },
  { label: "Cricket Net", category: "Sports", icon: <SportsCricket /> },
  { label: "Football Field", category: "Sports", icon: <SportsSoccer /> },
  { label: "Table Tennis", category: "Sports", icon: <SportsTennis /> },
  { label: "Volleyball Court", category: "Sports", icon: <SportsVolleyball /> },
  { label: "Skating Area", category: "Sports", icon: <RollerSkating /> },
  { label: "Kids Play Area", category: "Sports", icon: <ChildCare /> },

  // Security
  { label: "24x7 Security", category: "Security", icon: <Security /> },
  { label: "CCTV Surveillance", category: "Security", icon: <Videocam /> },
  { label: "Video Door Phone", category: "Security", icon: <Doorbell /> },
  { label: "Intercom", category: "Security", icon: <Phone /> },
  { label: "Gated Entry", category: "Security", icon: <DoorFront /> },
  { label: "Visitor Mgmt", category: "Security", icon: <People /> },
  { label: "Fire Safety", category: "Security", icon: <LocalFireDepartment /> },
  { label: "Access Control", category: "Security", icon: <Lock /> },
  { label: "Emergency Exit", category: "Security", icon: <ExitToApp /> },

  // Utilities
  { label: "Power Backup", category: "Utilities", icon: <Bolt /> },
  { label: "Water Supply", category: "Utilities", icon: <WaterDrop /> },
  { label: "Rainwater Harvesting", category: "Utilities", icon: <WaterDrop /> },
  { label: "Sewage Treatment", category: "Utilities", icon: <Business /> },
  { label: "Waste Mgmt", category: "Utilities", icon: <DeleteOutline /> },
  { label: "Solar Power", category: "Utilities", icon: <WbSunny /> },
  { label: "EV Charging", category: "Utilities", icon: <EvStation /> },
  { label: "Gas Pipeline", category: "Utilities", icon: <LocalGasStation /> },
  { label: "STP / WTP", category: "Utilities", icon: <Business /> },

  // Building Facilities
  { label: "High Speed Lift", category: "Building Facilities", icon: <Elevator /> },
  { label: "Lobby", category: "Building Facilities", icon: <Business /> },
  { label: "Reception", category: "Building Facilities", icon: <SupportAgent /> },
  { label: "Waiting Area", category: "Building Facilities", icon: <Chair /> },
  { label: "Basement Parking", category: "Building Facilities", icon: <DirectionsCar /> },
  { label: "Maintenance", category: "Building Facilities", icon: <Build /> },
  { label: "Housekeeping", category: "Building Facilities", icon: <CleaningServices /> },
  { label: "Service Lift", category: "Building Facilities", icon: <Elevator /> },
  { label: "Common Terrace", category: "Building Facilities", icon: <Deck /> },

  // Family & Convenience
  { label: "Kids Play Area", category: "Family & Convenience", icon: <ChildCare /> },
  { label: "Creche/Day Care", category: "Family & Convenience", icon: <ChildFriendly /> },
  { label: "Senior Citizen Area", category: "Family & Convenience", icon: <Park /> },
  { label: "Convenience Store", category: "Family & Convenience", icon: <Storefront /> },
  { label: "Pharmacy", category: "Family & Convenience", icon: <LocalPharmacy /> },
  { label: "ATM", category: "Family & Convenience", icon: <LocalAtm /> },
  { label: "Salon", category: "Family & Convenience", icon: <ContentCut /> },
  { label: "Laundry", category: "Family & Convenience", icon: <LocalLaundryService /> },
  { label: "Medical Centre", category: "Family & Convenience", icon: <LocalHospital /> },
];

const amenityCategories = [
  "All",
  "Recreation",
  "Fitness & Wellness",
  "Sports",
  "Security",
  "Utilities",
  "Building Facilities",
  "Family & Convenience",
];

const getHighlightKey = (item) => `${item.label}|${item.subtitle || ""}`;
const getAmenityKey = (item) => `${item.category}|${item.label}`;


const BankAuction = () => {
  const { userId, isGuest } = useContext(AuthContext);
  const navigate = useNavigate();
  const [uploadStatus, setUploadStatus] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // Amenity category tab state
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState("All");

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);
  const scriptInjectedRef = useRef(false); // ✅ prevents double script injection

  useEffect(() => {
    const checkSubscription = async () => {
      const result = await checkBankAuctionUploadLimit(userId);
      setUploadStatus(result);
      if (!result.canUpload) {
        setShowStatusModal(true);
      }
    };
    if (userId) checkSubscription();
  }, [userId]);

  useEffect(() => {
    if (isGuest) {
      setShowGuestModal(true);
    }
  }, [isGuest]);

  const [formData, setFormData] = useState({
    auctionId: '',
    bankName: '',
    propertyType: '',
    actionType: '',
    location: '',
    landmark: '',
    lat: '',
    long: '',
    cityTown: '',
    areaTown: '',
    area: '',
    possession: '',
    reservePrice: '',
    possessionStatus: '',
    emdAmount: '',
    bidIncrement: '',
    emdSubmission: '',
    auctionStartDate: '',
    auctionEndDate: '',
    bankContact: '',
    downloadAuctionFile: '',
    description: '',
    // ✅ NEW: Highlights + Amenities (stored as unique keys)
    highlights: [],
    amenities: [],
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
  const autocompleteServiceRef = useRef(null);
  const [location, setLocation] = useState(centerDefault);
  const [address, setAddress] = useState("");
  const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
  const [locationConfirmed, setLocationConfirmed] = useState(false);

  // ✅ Hardened loader: only injects script once, and reliably sets isGoogleLoaded
  useEffect(() => {
    const initGoogleMaps = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setIsGoogleLoaded(true);
        if (!autocompleteServiceRef.current) {
          autocompleteServiceRef.current =
            new window.google.maps.places.AutocompleteService();
        }
        return true;
      }
      return false;
    };

    // Already loaded (e.g. HMR / second mount)
    if (initGoogleMaps()) return;

    // Already injected once — just poll until ready
    if (scriptInjectedRef.current) {
      const poll = setInterval(() => {
        if (initGoogleMaps()) clearInterval(poll);
      }, 100);
      const stop = setTimeout(() => clearInterval(poll), 10000);
      return () => {
        clearInterval(poll);
        clearTimeout(stop);
      };
    }

    if (!window.google) {
      scriptInjectedRef.current = true;
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLEMAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // Poll until `.places` is truly available — `onload` can fire a tick early
        const poll = setInterval(() => {
          if (initGoogleMaps()) {
            clearInterval(poll);
            console.log("✅ Google Maps API loaded successfully");
          }
        }, 100);
        setTimeout(() => clearInterval(poll), 10000);
      };
      script.onerror = () => {
        console.error("❌ Failed to load Google Maps API");
      };
      document.head.appendChild(script);
    }

    return () => {
      autocompleteServiceRef.current = null;
    };
  }, []);

  // ✅ Central change handler with numeric validation
  const handleFormDataChange = (field, value) => {
    if (NUMERIC_ONLY_FIELDS.includes(field)) {
      if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
    }
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Toggle highlight by unique key
  const toggleHighlight = (key) => {
    setFormData((prev) => {
      const isSelected = prev.highlights.includes(key);
      const updatedHighlights = isSelected
        ? prev.highlights.filter((h) => h !== key)
        : [...prev.highlights, key];
      return { ...prev, highlights: updatedHighlights };
    });
  };

  // Toggle amenity by unique key
  const toggleAmenity = (key) => {
    setFormData((prev) => {
      const isSelected = prev.amenities.includes(key);
      const updatedAmenities = isSelected
        ? prev.amenities.filter((a) => a !== key)
        : [...prev.amenities, key];
      return { ...prev, amenities: updatedAmenities };
    });
  };

  const fetchPlaces = (input) => {
    if (!input || input.length < 3 || !isGoogleLoaded || !autocompleteServiceRef.current) {
      setLocationOptions([]);
      return;
    }
    autocompleteServiceRef.current.getPlacePredictions(
      {
        input,
        types: ["geocode", "establishment"],
        componentRestrictions: { country: "in" }
      },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          setLocationOptions(predictions.map((p) => p.description));
        } else {
          setLocationOptions([]);
        }
      }
    );
  };

  const debouncedFetchPlaces = useRef(null);

  useEffect(() => {
    debouncedFetchPlaces.current = debounce(fetchPlaces, 300);
  }, [isGoogleLoaded]);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // ══════════════════════════════════════════════════════════════
  // ✅ IMAGE UPLOAD — with preview, accumulator & remove support
  // ══════════════════════════════════════════════════════════════
  const [workPhotos, setWorkPhotos] = useState([]);
  const [photoPreviews, setPhotoPreviews] = useState([]);
  const fileInputRef = useRef(null);

  // Cleanup preview URLs on unmount
  useEffect(() => {
    return () => {
      photoPreviews.forEach((url) => URL.revokeObjectURL(url));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleWorkPhotosChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const validFiles = files.filter((file) =>
      file.type.startsWith("image/")
    );

    if (validFiles.length !== files.length) {
      alert("Please select image files only");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const merged = [...workPhotos, ...validFiles];

    if (merged.length > 4) {
      alert("You can upload a maximum of 4 images only");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));

    setWorkPhotos(merged);
    setPhotoPreviews((prev) => [...prev, ...newPreviews]);

    // Reset input so user can re-pick the same file
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleRemovePhoto = (index) => {
    URL.revokeObjectURL(photoPreviews[index]);

    setWorkPhotos((prev) => prev.filter((_, i) => i !== index));
    setPhotoPreviews((prev) => prev.filter((_, i) => i !== index));

    if (fileInputRef.current) fileInputRef.current.value = "";
  };


  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      setUsingCurrentLocation(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setLocation(pos);
          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
            );
            const data = await response.json();
            if (data.status == 'OK' && data.results.length > 0) {
              setAddress(data.results[0].formatted_address);
            } else {
              setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
            }
          } catch (error) {
            console.error('Google Maps API error:', error);
            setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
          }
        },
        (error) => {
          console.error("Error getting current location:", error);
          alert("Error getting current location. Please enable location services.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place && place.geometry) {
        setUsingCurrentLocation(false);
        const newLoc = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setLocation(newLoc);
        setAddress(place.formatted_address);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.bankName.trim()) newErrors.bankName = "Bank name is required";
    if (!formData.propertyType) newErrors.propertyType = "Please select a property type";
    if (!address || address.trim() === '') newErrors.location = "Please select a location";
    if (!formData.reservePrice) newErrors.reservePrice = "Reserve price is required";
    if (!formData.emdAmount) newErrors.emdAmount = "EMD amount is required";
    if (!formData.auctionStartDate) newErrors.auctionStartDate = "Auction start date is required";
    if (!formData.auctionEndDate) newErrors.auctionEndDate = "Auction end date is required";
    if (formData.auctionStartDate && formData.auctionEndDate) {
      const start = new Date(formData.auctionStartDate);
      const end = new Date(formData.auctionEndDate);
      if (end <= start) {
        newErrors.auctionEndDate = "End date must be after start date";
      }
    }
    if (!formData.bankContact.trim()) newErrors.bankContact = "Bank contact is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSave = async () => {
    if (isGuest) {
      setShowGuestModal(true);
      return;
    }

    if (workPhotos.length > 4) {
      alert("You can upload a maximum of 4 images only");
      return;
    }

    if (!validateForm()) return;

    setLoading(true);

    try {
      const check = await checkBankAuctionUploadLimit(userId);

      if (!check.canUpload) {
        setUploadStatus(check);
        setShowStatusModal(true);
        return;
      }

      const formPayload = new FormData();

      formPayload.append("user_id", userId);
      formPayload.append("bank_name", formData.bankName);
      formPayload.append("property_type", formData.propertyType);
      formPayload.append("action_type", formData.actionType);
        formPayload.append("landmark", formData.landmark);
      formPayload.append("location", address || "");
      formPayload.append("lat", location?.lat || "");
      formPayload.append("long", location?.lng || "");
      formPayload.append("city_town", formData.cityTown);
      formPayload.append("area_town", formData.areaTown);
      formPayload.append("area", formData.area);
      formPayload.append("units", "");
      formPayload.append("possession", formData.possession);
      formPayload.append("reserve_price", formData.reservePrice);
      formPayload.append("possession_status", formData.possessionStatus);
      formPayload.append("emd_amount", formData.emdAmount);
      formPayload.append("bid_increment", formData.bidIncrement);
      formPayload.append("emd_submission", formData.emdSubmission);
      formPayload.append("auction_start_datetime", formData.auctionStartDate);
      formPayload.append("auction_end_datetime", formData.auctionEndDate);
      formPayload.append("bank_contact_details", formData.bankContact);
      formPayload.append("description", formData.description);
      formPayload.append("admin_status", "Pending");

      // ✅ Property Highlights payload
      const highlightPayload = formData.highlights
        .map((key) => highlightOptions.find((o) => getHighlightKey(o) === key))
        .filter(Boolean)
        .map((item, index) => ({
          name: item.label,
          icon: getIconKey(item.label),
          order: index + 1,
          is_active: true,
        }));
      formPayload.append("property_highlights", JSON.stringify(highlightPayload));
      formPayload.append("highlights", JSON.stringify(highlightPayload));

      // ✅ Property Amenities payload (deduped by name)
      const seenAmenities = new Set();
      const amenityPayload = formData.amenities
        .map((key) => amenitiesOptions.find((o) => getAmenityKey(o) === key))
        .filter(
          (item) =>
            item && !seenAmenities.has(item.label) && seenAmenities.add(item.label)
        )
        .map((item, index) => ({
          name: item.label,
          icon: getIconKey(item.label),
          order: index + 1,
          is_active: true,
        }));
      formPayload.append("property_amenities", JSON.stringify(amenityPayload));
      formPayload.append("amenities", JSON.stringify(amenityPayload));

      // Existing document uploads
      selectedFiles.forEach((file) => {
        formPayload.append("new_documents", file);
      });

      // Property image uploads (maximum 4)
      workPhotos.forEach((file) => {
        formPayload.append("new_property_images", file);
      });

      console.log("📤 Submitting auction with documents:", selectedFiles.length);
      console.log("🖼️ Property images:", workPhotos.length);
      console.log("⭐ Highlights payload:", highlightPayload);
      console.log("🏊 Amenities payload:", amenityPayload);

      const response = await fetch(`${BASE_URL}/auction-property/`, {
        method: "POST",
        body: formPayload,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("✅ Auction saved successfully:", result);

        setAlertMessage("Auction saved successfully!");
        setShowSuccess(true);
      } else {
        const errorText = await response.text();
        console.error("❌ Failed to save auction:", errorText);

        setAlertMessage("Failed to save auction. Please try again.");
        setShowFailure(true);
      }
    } catch (err) {
      console.error("🚨 Error:", err);
      setAlertMessage("An error occurred while saving. Please try again.");
      setShowFailure(true);
    } finally {
      setLoading(false);
    }
  };


  const handleCancel = () => navigate(-1);
  const handleBackClick = () => navigate(-1);

  const propertyTypeOptions = [
    'Plots',
    'Residential Building',
    'Commercial Building',
    'Land',
    'Flat',
    'House',
    'Villa',
    "PG/Hostels",
    "Offices",
    "Hospitals",
    "Schools/Colleges",
    "Fuel Stations",
    "Factories",
    "Manufacturing Units",
    "Industrial sheds",
    "Shopping Complexes",
    "Warehouses/logistics",
    "Restaurants/Bar/Pubs",
  ];

  const propertyTypeIcons = {
    'Plots': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Home sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'Residential Building': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <House sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'Commercial Building': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <BusinessCenter sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'Land': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Landscape sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'Flat': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Apartment sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'House': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <House sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
    'Villa': (
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        backgroundColor: '#F5EAD8',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Villa sx={{ color: '#8B6914', fontSize: 20 }} />
      </Box>
    ),
  };

  // ============================================================
  // Render Highlights + Amenities section
  // ============================================================
  const renderHighlightsAndAmenities = () => (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 'bold', mb: 2, color: '#3D2B1F' }}
      >
        Property Highlights
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '8px',
          mb: 4,
        }}
      >
        {highlightOptions.map((item) => {
          const itemKey = getHighlightKey(item);
          const isSelected = formData.highlights.includes(itemKey);
          return (
            <Box
              key={itemKey}
              onClick={() => toggleHighlight(itemKey)}
              sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 0.5,
                p: 1,
                borderRadius: '10px',
                border: `1px solid ${isSelected ? '#9a4f20' : '#E0E0E0'}`,
                backgroundColor: isSelected ? '#F5EDE4' : '#FFFFFF',
                cursor: 'pointer',
                transition: 'all 0.2s',
                minHeight: '90px',
                justifyContent: 'center',
                overflow: 'hidden',
                '&:hover': {
                  backgroundColor: isSelected ? '#EDE0D4' : '#FAFAFA',
                  borderColor: isSelected ? '#9a4f20' : '#B0B0B0',
                },
              }}
            >
              {isSelected && (
                <CheckCircle
                  sx={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    fontSize: '14px',
                    color: '#9a4f20',
                  }}
                />
              )}
              <Box
                sx={{
                  color: '#9a4f20',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px',
                  mb: 0.5,
                }}
              >
                {item.icon}
              </Box>
              <Typography
                sx={{
                  fontSize: '10.5px',
                  fontWeight: 600,
                  color: '#1A1A1A',
                  lineHeight: 1.2,
                  wordBreak: 'break-word',
                }}
              >
                {item.label}
              </Typography>
              {item.subtitle && (
                <Typography
                  sx={{
                    fontSize: '9px',
                    fontWeight: 400,
                    color: '#888',
                    lineHeight: 1.2,
                    wordBreak: 'break-word',
                  }}
                >
                  {item.subtitle}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>

      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 'bold', mb: 1.5, color: '#3D2B1F' }}
      >
        Amenities
      </Typography>

      {/* Category Tabs */}
      <Box
        sx={{
          mb: 2,
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          borderBottom: '1px solid #E0E0E0',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        <Stack direction="row" spacing={0} sx={{ display: 'inline-flex' }}>
          {amenityCategories.map((cat) => (
            <Box
              key={cat}
              onClick={() => setSelectedAmenityCategory(cat)}
              sx={{
                px: 1.5,
                py: 1,
                cursor: 'pointer',
                borderBottom:
                  selectedAmenityCategory === cat
                    ? '2px solid #9a4f20'
                    : '2px solid transparent',
                flexShrink: 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: selectedAmenityCategory === cat ? 600 : 500,
                  color: selectedAmenityCategory === cat ? '#9a4f20' : '#666',
                  whiteSpace: 'nowrap',
                }}
              >
                {cat}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>

      {/* Amenities Grid */}
      {(selectedAmenityCategory === 'All'
        ? amenityCategories.filter((c) => c !== 'All')
        : [selectedAmenityCategory]
      ).map((cat) => {
        const items = amenitiesOptions.filter((a) => a.category === cat);
        if (items.length === 0) return null;

        return (
          <Box key={cat} sx={{ mb: 3 }}>
            <Typography
              sx={{ fontSize: '13px', fontWeight: 700, color: '#333', mb: 1.5 }}
            >
              {cat}
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '8px',
              }}
            >
              {items.map((item) => {
                const itemKey = getAmenityKey(item);
                const isSelected = formData.amenities.includes(itemKey);
                return (
                  <Box
                    key={itemKey}
                    onClick={() => toggleAmenity(itemKey)}
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      gap: 0.5,
                      p: 1,
                      borderRadius: '10px',
                      border: `1px solid ${isSelected ? '#9a4f20' : '#E0E0E0'}`,
                      backgroundColor: isSelected ? '#F5EDE4' : '#FFFFFF',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      minHeight: '74px',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      '&:hover': {
                        backgroundColor: isSelected ? '#EDE0D4' : '#FAFAFA',
                        borderColor: isSelected ? '#9a4f20' : '#B0B0B0',
                      },
                    }}
                  >
                    {isSelected && (
                      <CheckCircle
                        sx={{
                          position: 'absolute',
                          top: 4,
                          right: 4,
                          fontSize: '13px',
                          color: '#9a4f20',
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        color: '#9a4f20',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: '9.5px',
                        fontWeight: 600,
                        color: '#1A1A1A',
                        lineHeight: 1.2,
                        wordBreak: 'break-word',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );

  return (
    <>
      <SearchBar onBackClick={handleBackClick} />

      <Box sx={{
        padding: '16px',
        backgroundColor: '#f5f1eb',
        minHeight: '100vh',
        height: '100%',
        marginTop: "15%",
        paddingBottom: "80px"
      }}>
        <FilterContainer>
          {/* Basic Information */}
          <SectionTitle>Basic Information</SectionTitle>

          <FormControl fullWidth sx={{ mb: 2 }} size="small">
            <TextField
              label="Bank Name *"
              value={formData.bankName}
              onChange={(e) => { handleFormDataChange('bankName', e.target.value); setErrors(prev => ({ ...prev, bankName: '' })); }}
              variant="outlined"
              size="small"
              error={!!errors.bankName}
              helperText={errors.bankName || ''}
            />
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }} size="small" error={!!errors.propertyType}>
            <InputLabel
              id="property-type-label"
              sx={{ color: '#8B6914', '&.Mui-focused': { color: '#8B6914' } }}
            >
              Property Type *
            </InputLabel>
            <Select
              labelId="property-type-label"
              value={formData.propertyType}
              label="Property Type *"
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#8B6914' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#6B4F12' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#8B6914',
                  borderWidth: '2px',
                },
                '& .MuiSelect-select': { display: 'flex', alignItems: 'center', gap: 1 },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 440,
                    '& .MuiMenuItem-root': {
                      display: 'flex', alignItems: 'center', gap: 1.5,
                      padding: '2px 16px', minHeight: '32px',
                    },
                    '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: '#F5EDE4',
                      '&:hover': { backgroundColor: '#E8DDD0' },
                    },
                    '& .MuiMenuItem-root:hover': { backgroundColor: '#F5EDE4' },
                  }
                }
              }}
              onChange={(e) => {
                handleFormDataChange('propertyType', e.target.value);
                setErrors(prev => ({ ...prev, propertyType: '' }));
              }}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {selected && propertyTypeIcons[selected]}
                  <Typography sx={{ color: '#3D2B1F' }}>
                    {selected || 'Select Property Type'}
                  </Typography>
                </Box>
              )}
            >
              {propertyTypeOptions.map((type) => (
                <MenuItem
                  key={type}
                  value={type}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: 2,
                    padding: '8px 16px',
                    '&:hover': { backgroundColor: '#F5EDE4 !important' },
                    '&.Mui-selected': {
                      backgroundColor: '#E8DDD0 !important',
                      '&:hover': { backgroundColor: '#E8DDD0 !important' },
                    }
                  }}
                >
                  <Box sx={{ minWidth: 30 }}>
                    {propertyTypeIcons[type] || <Home sx={{ color: '#8B6914', fontSize: 20 }} />}
                  </Box>
                  <Typography sx={{ color: '#3D2B1F', fontWeight: 500 }}>
                    {type}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
            {errors.propertyType && (
              <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5, ml: 1.5 }}>
                {errors.propertyType}
              </Typography>
            )}
          </FormControl>

          <TextField
            fullWidth
            label="Action Type"
            placeholder="Enter action type"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.actionType}
            onChange={(e) => handleFormDataChange('actionType', e.target.value)}
          />
 <Box sx={{ mb: 3 }}>
                                      <TextField
                                        fullWidth
                                        label="Property Nearest Landmark"
                                        placeholder="Enter nearest landmark"
                                        variant="outlined"
                                        value={formData.landmark || ''}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            landmark: e.target.value,
                                          }))
                                        }
                                      />
                                    </Box>
        
          {isGoogleLoaded && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Location (pin point location on map)
              </Typography>

              <Autocomplete
                onLoad={(autocomplete) => {
                  autocompleteRef.current = autocomplete;
                }}
                onPlaceChanged={onPlaceChanged}
              >
                <TextField
                  fullWidth
                  label="Search Location *"
                  variant="outlined"
                  value={address}
                  onChange={(e) => { setAddress(e.target.value); setErrors(prev => ({ ...prev, location: '' })); }}
                  error={!!errors.location}
                  helperText={errors.location || ''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={getCurrentLocation} edge="end">
                          <MyLocationIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Autocomplete>

              <div style={{ ...containerStyle, position: 'relative' }}>
                <GoogleMap
                  mapContainerStyle={{ width: '100%', height: '100%' }}
                  center={location}
                  zoom={15}
                  options={{ gestureHandling: 'greedy' }}
                  onLoad={(map) => { mapRef.current = map; }}
                  onDragStart={() => setLocationConfirmed(false)}
                />

                <div style={{
                  position: 'absolute', top: '50%', left: '50%',
                  transform: 'translate(-50%, -100%)', pointerEvents: 'none', zIndex: 10,
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                    <path fill="#ff0000" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    if (window.google && window.google.maps && mapRef.current) {
                      const center = mapRef.current.getCenter();
                      const lat = center.lat();
                      const lng = center.lng();
                      setLocation({ lat, lng });
                      const geocoder = new window.google.maps.Geocoder();
                      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                        if (status === 'OK' && results[0]) {
                          const selectedAddress = results[0].formatted_address;
                          setAddress(selectedAddress);
                          setFormData(prev => ({
                            ...prev,
                            location: selectedAddress,
                            lat: lat.toString(),
                            long: lng.toString(),
                          }));
                        } else {
                          const fallback = `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
                          setAddress(fallback);
                          setFormData(prev => ({
                            ...prev,
                            location: fallback,
                            lat: lat.toString(),
                            long: lng.toString(),
                          }));
                        }
                        setLocationConfirmed(true);
                      });
                    }
                  }}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: locationConfirmed ? 'green' : 'red',
                    border: 'none', borderRadius: '50%', width: '44px', height: '44px',
                    cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
                    position: 'absolute', right: '10px', top: '45%',
                    transform: 'translateY(-50%)', zIndex: 10,
                    transition: 'background-color 0.3s ease',
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                    <path fill="white" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </button>
              </div>
            </Box>
          )}

          <TextField
            fullWidth
            label="City/Town"
            placeholder="e.g. Bangalore"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.cityTown}
            onChange={(e) => handleFormDataChange('cityTown', e.target.value)}
          />

          <TextField
            fullWidth
            label="Area/Town"
            placeholder="e.g., Yeswanthpura"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.areaTown}
            onChange={(e) => handleFormDataChange('areaTown', e.target.value)}
          />

          <TextField
            fullWidth
            label="Area"
            placeholder="e.g., 900"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.area}
            onChange={(e) => handleFormDataChange('area', e.target.value)}
            inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
          />

          {/* Possession Details */}
          <SectionTitle>Possession Details</SectionTitle>

          <FormControl fullWidth sx={{ mb: 2 }} size="small">
            <InputLabel>Possession Status</InputLabel>
            <Select
              value={formData.possessionStatus}
              label="Possession Status"
              onChange={(e) => handleFormDataChange('possessionStatus', e.target.value)}
            >
              <MenuItem value="Physical">Physical</MenuItem>
              <MenuItem value="Symbolic">Symbolic</MenuItem>
              <MenuItem value="Symbolic/Physical">Symbolic/Physical</MenuItem>
            </Select>
          </FormControl>

          {/* Auction Details */}
          <SectionTitle>Auction Details</SectionTitle>

          <TextField
            fullWidth
            label="Reserve Price *"
            placeholder="e.g., 3132000"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.reservePrice}
            onChange={(e) => { handleFormDataChange('reservePrice', e.target.value); setErrors(prev => ({ ...prev, reservePrice: '' })); }}
            inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
            error={!!errors.reservePrice}
            helperText={errors.reservePrice || ''}
          />

          <TextField
            fullWidth
            label="EMD Amount *"
            placeholder="e.g., 313200"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.emdAmount}
            onChange={(e) => { handleFormDataChange('emdAmount', e.target.value); setErrors(prev => ({ ...prev, emdAmount: '' })); }}
            inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
            error={!!errors.emdAmount}
            helperText={errors.emdAmount || ''}
          />

          <TextField
            fullWidth
            label="Bid Increment"
            placeholder="e.g., 10000"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.bidIncrement}
            onChange={(e) => handleFormDataChange('bidIncrement', e.target.value)}
            inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
          />

          <TextField
            fullWidth
            label="EMD Submission Date & Time"
            type="datetime-local"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
            value={formData.emdSubmission}
            onChange={(e) => handleFormDataChange('emdSubmission', e.target.value)}
          />

          <TextField
            fullWidth
            label="Auction Start Date & Time *"
            type="datetime-local"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
            value={formData.auctionStartDate}
            onChange={(e) => { handleFormDataChange('auctionStartDate', e.target.value); setErrors(prev => ({ ...prev, auctionStartDate: '' })); }}
            error={!!errors.auctionStartDate}
            helperText={errors.auctionStartDate || ''}
          />

          <TextField
            fullWidth
            label="Auction End Date & Time *"
            type="datetime-local"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
            value={formData.auctionEndDate}
            onChange={(e) => { handleFormDataChange('auctionEndDate', e.target.value); setErrors(prev => ({ ...prev, auctionEndDate: '' })); }}
            error={!!errors.auctionEndDate}
            helperText={errors.auctionEndDate || ''}
          />

          {/* Contact & Files */}
          <SectionTitle>Contact & Documents</SectionTitle>

          <TextField
            fullWidth
            label="Bank Contact Details *"
            placeholder="e.g., 9876XXXXXX"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={formData.bankContact}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              handleFormDataChange("bankContact", value);
              setErrors(prev => ({ ...prev, bankContact: '' }));
            }}
            type="tel"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 10,
            }}
            error={!!errors.bankContact}
            helperText={errors.bankContact || ''}
          />


          {/* ══════════════════════════════════════════════════════
              Property Image Upload — with preview & accumulator
          ══════════════════════════════════════════════════════ */}
          <Box sx={{ mt: 3, mb: 2, width: "100%" }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, color: "#3D2B1F" }}
            >
              Upload Property Images
            </Typography>

            <Button
              component="label"
              variant="outlined"
              fullWidth
              startIcon={<CloudUploadIcon />}
              disabled={loading || isGuest || workPhotos.length >= 4}
              sx={{
                py: 1.5,
                borderColor: "#8B6914",
                color: "#8B6914",
                borderRadius: "8px",
                "&:hover": {
                  borderColor: "#6B4F12",
                  backgroundColor: "rgba(139, 105, 20, 0.04)",
                },
                "&.Mui-disabled": {
                  borderColor: "#ccc",
                  color: "#999",
                },
              }}
            >
              {workPhotos.length >= 4 ? "Maximum 4 images selected" : "Upload Images"}

              <input
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleWorkPhotosChange}
                ref={fileInputRef}
              />
            </Button>

            <Typography
              variant="caption"
              sx={{ color: "#8B6914", display: "block", mt: 1 }}
            >
              Maximum 4 images allowed ({4 - workPhotos.length} remaining)
            </Typography>

            {/* Preview grid */}
            {workPhotos.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
                  Selected Images ({workPhotos.length}/4)
                </Typography>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 1.2,
                  }}
                >
                  {photoPreviews.map((previewUrl, index) => (
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        width: "100%",
                        paddingTop: "100%",
                        borderRadius: "8px",
                        overflow: "hidden",
                        border: "1px solid #E0D6C3",
                        backgroundColor: "#FAF8F5",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                      }}
                    >
                      <Box
                        component="img"
                        src={previewUrl}
                        alt={`preview-${index}`}
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />

                      <IconButton
                        size="small"
                        onClick={() => handleRemovePhoto(index)}
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          width: 22,
                          height: 22,
                          backgroundColor: "rgba(0,0,0,0.6)",
                          color: "#fff",
                          p: 0,
                          "&:hover": {
                            backgroundColor: "rgba(220,0,0,0.85)",
                          },
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18" />
                          <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>

          {/* ✅ Highlights + Amenities section */}
          {renderHighlightsAndAmenities()}

          {/* Description */}
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3D2B1F" }}
            >
              Description
            </Typography>

            <TextField
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              inputProps={{ maxLength: 1500 }}
              name="description"
              value={formData.description || ""}
              onChange={(e) =>
                handleFormDataChange("description", e.target.value)
              }
              placeholder="Enter property description..."
              disabled={loading || isGuest}
              sx={{ mb: 1 }}
            />

            <Typography
              variant="caption"
              sx={{ color: "#8B6914" }}
            >
              {(formData.description || "").length}/1500
            </Typography>
          </Box>

          <>
            <FullScreenLoader open={loading} text="Saving..." />

            <Stack direction="row" spacing={1} sx={{ mt: 3, mb: 2 }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={handleCancel}
                disabled={loading}
                sx={{
                  borderRadius: '8px',
                  borderColor: '#8B4513',
                  color: '#8B4513',
                  '&:hover': {
                    borderColor: '#654321',
                    backgroundColor: 'rgba(139, 69, 19, 0.04)'
                  }
                }}
              >
                Cancel
              </Button>

              <StyledButton
                fullWidth
                onClick={handleSave}
                disabled={loading || isGuest || (uploadStatus && !uploadStatus.canUpload)}
              >
                {uploadStatus && !uploadStatus.canUpload
                  ? "Upload Limit Reached"
                  : isGuest
                  ? "Login to Save"
                  : "Save"}
              </StyledButton>
            </Stack>
          </>
        </FilterContainer>
      </Box>

      <SubscriptionModal
        open={showStatusModal}
        type={uploadStatus?.reason === "NO_SUBSCRIPTION" ? "NO_SUBSCRIPTION" : "LIMIT_EXCEEDED"}
        onClose={() => setShowStatusModal(false)}
      />

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />

      {showSuccess && (
        <SuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            navigate("/post");
          }}
        />
      )}

      {showFailure && (
        <FailureAlert
          message={alertMessage}
          onClose={() => {
            console.log("Closing failure alert");
            setShowFailure(false);
            setAlertMessage("");
            navigate("/post-bank-properties");
          }}
        />
      )}

      <FormsBottomNavbar />
    </>
  );
};

export default BankAuction;